import { getFirstVisibleElement } from './getFirstVisibleElement';
import { waitForPageOffsetChange } from './waitForPageOffsetChange';

export async function withScrollRestoration<T>(action: () => Promise<T>) {
  const firstVisibleElement = getFirstVisibleElement();

  if (!firstVisibleElement) {
    return action();
  }

  const initialViewportOffset = firstVisibleElement.getBoundingClientRect().top;
  const initialPageOffset = window.scrollY + initialViewportOffset;

  const result = await action();

  const hasPageOffsetChanged = await waitForPageOffsetChange(firstVisibleElement, initialPageOffset);

  if (hasPageOffsetChanged) {
    const newPageOffset = window.scrollY + firstVisibleElement.getBoundingClientRect().top;
    window.scrollTo(0, newPageOffset - initialViewportOffset);
  }

  return result;
}
